// extracted by mini-css-extract-plugin
module.exports = {"partner":"ijLkv","linkSelect":"vXBPL","header":"_3xi2F","partnerContent":"N98HK","sidebar":"_2eVZx","partner-content":"_12jGW","links":"_16mTP"};